if (!customElements.get("product-addon")) {
  customElements.define(
    "product-addon",
    class ProductAddon extends HTMLElement {
      constructor() {
        super();

        this.blockId = this.dataset.blockId;
        this.checkboxes = this.querySelectorAll(
          `.addon-checkbox-${this.blockId}.addon-checkbox-item`,
        );
        this.quantityButtons = this.querySelectorAll(
          `.addon-quantity-btn-${this.blockId}`,
        );

        this.init();
      }

      init() {
        this.setupCheckboxListeners();
        this.setupQuantityButtons();
      }

      setupCheckboxListeners() {
        this.checkboxes.forEach((checkbox, index) => {
          const addonIndex = index + 1;
          const details = document.getElementById(
            `addon-details-${this.blockId}-${addonIndex}`,
          );

          if (details) {
            if (checkbox.checked) {
              this.toggleAddonDetails(checkbox, details);
            }
            checkbox.addEventListener("change", () => {
              this.toggleAddonDetails(checkbox, details);
            });
          }
        });
      }

      toggleAddonDetails(checkbox, details) {
        details.style.display = checkbox.checked ? "flex" : "none";
      }

      setupQuantityButtons() {
        this.quantityButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            this.handleQuantityChange(button);
          });
        });
      }

      handleQuantityChange(button) {
        const targetId = button.getAttribute("data-target");
        const input = document.getElementById(targetId);
        const action = button.getAttribute("data-action");

        if (!input) return;

        let value = parseInt(input.value) || 1;

        if (action === "increase") {
          value++;
        } else if (action === "decrease" && value > 1) {
          value--;
        }

        input.value = value;
      }

      // Public method to get selected addons (called by product-form)
      getSelectedAddons() {
        const addons = [];
        const checkedBoxes = this.querySelectorAll(
          `.addon-checkbox-${this.blockId}.addon-checkbox-item:checked`,
        );

        checkedBoxes.forEach((checkbox) => {
          const variantId = checkbox.getAttribute("data-variant-id");
          const quantityInputId = checkbox.getAttribute("data-quantity-input");
          const quantityInput = document.getElementById(quantityInputId);

          if (variantId && quantityInput) {
            addons.push({
              id: parseInt(variantId),
              quantity: parseInt(quantityInput.value) || 1,
            });
          }
        });

        return addons;
      }
    },
  );
}
